module.exports = __webpack_public_path__ + "static/fonts/Outfit-Bold.e788bf14.ttf";